import { render } from "./AboutContent.vue?vue&type=template&id=4be8426e&ts=true"
import script from "./AboutContent.vue?vue&type=script&lang=ts"
export * from "./AboutContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__